Eshop.confirm = function(text, options, callback) {
    var settings = $.extend({
        title: text,
        text: "",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: 'Zrušiť',
        confirmButtonColor: "#060659",
        confirmButtonText: "Ok",
        closeOnConfirm: true
    }, options);

    swal(settings, callback);
}